Object.defineProperty(exports,"__esModule",{value:true});var Platform={OS:'web',select:function select(obj){return'web'in obj?obj.web:obj.default;}};exports.default=Platform;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-native-web/dist/apis/Platform/index.js
 ** module id = 338
 ** module chunks = 0
 **/